/**
 * Desi Firms Design System - Breakpoint Tokens
 * Mobile-first responsive design system
 */

export const breakpoints = {
  xs: '480px',
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px',
};

// Breakpoint values as numbers (for JS comparisons)
export const breakpointValues = {
  xs: 480,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
};

// Media query helpers for styled-components
export const media = {
  xs: `@media (min-width: ${breakpoints.xs})`,
  sm: `@media (min-width: ${breakpoints.sm})`,
  md: `@media (min-width: ${breakpoints.md})`,
  lg: `@media (min-width: ${breakpoints.lg})`,
  xl: `@media (min-width: ${breakpoints.xl})`,
  '2xl': `@media (min-width: ${breakpoints['2xl']})`,

  // Max-width queries (for mobile-first overrides)
  maxXs: `@media (max-width: ${parseInt(breakpoints.xs) - 1}px)`,
  maxSm: `@media (max-width: ${parseInt(breakpoints.sm) - 1}px)`,
  maxMd: `@media (max-width: ${parseInt(breakpoints.md) - 1}px)`,
  maxLg: `@media (max-width: ${parseInt(breakpoints.lg) - 1}px)`,
  maxXl: `@media (max-width: ${parseInt(breakpoints.xl) - 1}px)`,

  // Range queries
  smOnly: `@media (min-width: ${breakpoints.sm}) and (max-width: ${parseInt(breakpoints.md) - 1}px)`,
  mdOnly: `@media (min-width: ${breakpoints.md}) and (max-width: ${parseInt(breakpoints.lg) - 1}px)`,
  lgOnly: `@media (min-width: ${breakpoints.lg}) and (max-width: ${parseInt(breakpoints.xl) - 1}px)`,

  // Device-specific
  mobile: `@media (max-width: ${parseInt(breakpoints.md) - 1}px)`,
  tablet: `@media (min-width: ${breakpoints.md}) and (max-width: ${parseInt(breakpoints.lg) - 1}px)`,
  desktop: `@media (min-width: ${breakpoints.lg})`,

  // Interaction queries
  hover: '@media (hover: hover)',
  touch: '@media (hover: none)',

  // Preference queries
  prefersReducedMotion: '@media (prefers-reduced-motion: reduce)',
  prefersDark: '@media (prefers-color-scheme: dark)',
  prefersLight: '@media (prefers-color-scheme: light)',

  // Print
  print: '@media print',
};

// Container widths per breakpoint
export const containerWidths = {
  sm: '100%',
  md: '720px',
  lg: '960px',
  xl: '1140px',
  '2xl': '1320px',
};

// Grid columns per breakpoint (for reference)
export const gridColumns = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 12,
  xl: 12,
  '2xl': 12,
};

export default {
  breakpoints,
  breakpointValues,
  media,
  containerWidths,
  gridColumns,
};
